export default {
	setCurrentEvent(state, payload) {
		state.currentEvent = payload;
	}
};
